const ShowMenuOverlay = () => {
  return (document.getElementById("nav-menu-overlay").style.left = "0%");
};

export default ShowMenuOverlay;
